import { saveAs } from 'file-saver'
import { getApi, OK, postApi, strArray } from '../util'
import Encoding from 'encoding-japanese'

const state = {
    apiStatus: null,
    invoicesList: null,
    invoicesDetail: null,
    invoicesRegisterList: null,
    registerParams: null,
    filterParams: null,
}

const mutations = {
    setApiStatus(state, data) {
        state.apiStatus = data
    },
    setInvoicesList(state, data) {
        state.invoicesList = data
    },
    setInvoicesDetail(state, data) {
        state.invoicesDetail = data
    },
    setInvoicesRegisterList(state, data) {
        state.invoicesRegisterList = data
    },
    setRegisterParams(state, data) {
        state.registerParams = data
    },
    setFilterParams(state, data) {
        state.filterParams = data
    },
}

const actions = {
    // 請求書一覧取得
    async getInvoicesApi(context, params) {
        context.commit('setApiStatus', null)
        context.commit('setInvoicesList', null)
        const response = await getApi('get_invoices_list', params)
        if (response.data.code === OK) {
            context.commit('setApiStatus', true)
            context.commit('setInvoicesList', response.data.data)
            return false
        }

        // 共通エラー処理
        context.commit('error/setApiStatus', true, { root: true })
        context.commit('error/setErrorCode', response.data.code, { root: true })
    },
    // 請求書登録一覧取得
    async getInvoicesRegisterListApi(context, params) {
        context.commit('setApiStatus', null)
        const response = await getApi('get_invoices_slip_detail', params)
        if (response.data.code === OK) {
            context.commit('setApiStatus', true)
            context.commit('setInvoicesRegisterList', response.data.data)
            return false
        }

        // 共通エラー処理
        context.commit('error/setApiStatus', true, { root: true })
        context.commit('error/setErrorCode', response.data.code, { root: true })
    },
    // 請求書作成、更新
    async postInvoices(context, params) {
        context.commit('setApiStatus', null)
        const response = await postApi('send_invoices_slip', params)
        if (response.data.code === OK) {
            context.commit('setApiStatus', true)
            return false
        }

        // 共通エラー処理
        context.commit('error/setApiStatus', true, { root: true })
        context.commit('error/setErrorCode', response.data.code, { root: true })
    },
    // 請求書詳細取得
    async getInvoicesListApi(context, params) {
        context.commit('setApiStatus', null)
        const response = await getApi('get_invoices_detail', params)
        if (response.data.code === OK) {
            context.commit('setApiStatus', true)
            context.commit('setInvoicesDetail', response.data.data)
            return false
        }

        // 共通エラー処理
        context.commit('error/setApiStatus', true, { root: true })
        context.commit('error/setErrorCode', response.data.code, { root: true })
    },
    // 旧請求書詳細取得
    async getOldInvoicesListApi(context, params) {
        context.commit('setApiStatus', null)
        const response = await getApi('get_old_invoice_detail', params)
        if (response.data.code === OK) {
            context.commit('setApiStatus', true)
            context.commit('setInvoicesDetail', response.data.data)
            return false
        }

        // 共通エラー処理
        context.commit('error/setApiStatus', true, { root: true })
        context.commit('error/setErrorCode', response.data.code, { root: true })
    },
    // 請求書CSV取得
    async getInvoicesCsvApi(context, params) {
        context.commit('setApiStatus', null)
        const response = await getApi('import_invoices_csv', params)
        if (response.data.code === OK) {
            context.commit('setApiStatus', true)
            let mineType = 'text/csv'
            const name = response.data.data.name
            const shiftJisCodeList = Encoding.convert(strArray(response.data.data.csv), 'sjis', 'unicode')
            const uInt8List = new Uint8Array(shiftJisCodeList)
            const blob = new Blob([uInt8List], { type: mineType })
            saveAs(blob, name)
            return false
        }

        // 共通エラー処理
        context.commit('error/setApiStatus', true, { root: true })
        context.commit('error/setErrorCode', response.data.code, { root: true })
    },
    // 請求書PDF取得
    async getInvoicesPdfApi(context, params) {
        context.commit('setApiStatus', null)
        const response = await getApi('import_invoices_pdf', params)
        if (response.data.code === OK) {
            context.commit('setApiStatus', true)
            const name = response.data.data.name
            saveAs(response.data.data.url, name)
            return false
        }

        // 共通エラー処理
        context.commit('error/setApiStatus', true, { root: true })
        context.commit('error/setErrorCode', response.data.code, { root: true })
    },
    // チェックリストPDF取得
    async getInvoicesChecklistApi(context, params) {
        context.commit('setApiStatus', null)
        const response = await getApi('import_checklist_pdf', params)
        if (response.data.code === OK) {
            context.commit('setApiStatus', true)
            const name = response.data.data.name
            saveAs(response.data.data.url, name)
            return false
        }

        // 共通エラー処理
        context.commit('error/setApiStatus', true, { root: true })
        context.commit('error/setErrorCode', response.data.code, { root: true })
    },
    // 旧請求書CSV取得
    async getOldInvoicesCsvApi(context, params) {
        context.commit('setApiStatus', null)
        const response = await getApi('import_old_invoices_csv', params)
        if (response.data.code === OK) {
            context.commit('setApiStatus', true)
            let mineType = 'text/csv'
            const name = response.data.data.name
            const shiftJisCodeList = Encoding.convert(strArray(response.data.data.csv), 'sjis', 'unicode')
            const uInt8List = new Uint8Array(shiftJisCodeList)
            const blob = new Blob([uInt8List], { type: mineType })
            saveAs(blob, name)
            return false
        }

        // 共通エラー処理
        context.commit('error/setApiStatus', true, { root: true })
        context.commit('error/setErrorCode', response.data.code, { root: true })
    },
    // 旧請求書PDF取得
    async getOldInvoicesPdfApi(context, params) {
        context.commit('setApiStatus', null)
        const response = await getApi('import_old_invoices_pdf', params)
        if (response.data.code === OK) {
            context.commit('setApiStatus', true)
            const name = response.data.data.name
            saveAs(response.data.data.url, name)
            return false
        }

        // 共通エラー処理
        context.commit('error/setApiStatus', true, { root: true })
        context.commit('error/setErrorCode', response.data.code, { root: true })
    },
    // 旧チェックリストPDF取得
    async getOldInvoicesChecklistApi(context, params) {
        context.commit('setApiStatus', null)
        const response = await getApi('import_old_checklist_pdf', params)
        if (response.data.code === OK) {
            context.commit('setApiStatus', true)
            const name = response.data.data.name
            saveAs(response.data.data.url, name)
            return false
        }

        // 共通エラー処理
        context.commit('error/setApiStatus', true, { root: true })
        context.commit('error/setErrorCode', response.data.code, { root: true })
    },
    // 請求処理
    async postUpdateInvoices(context, params) {
        context.commit('setApiStatus', null)
        const response = await postApi('update_payment_flag', params)
        if (response.data.code === OK) {
            context.commit('setApiStatus', true)
            return false
        }

        // 共通エラー処理
        context.commit('error/setApiStatus', true, { root: true })
        context.commit('error/setErrorCode', response.data.code, { root: true })
    },
    // 請求削除
    async deleteInvoices(context, params) {
        context.commit('setApiStatus', null)
        const response = await postApi('delete_invoice', params)
        if (response.data.code === OK) {
            context.commit('setApiStatus', true)
            return false
        }

        // 共通エラー処理
        context.commit('error/setApiStatus', true, { root: true })
        context.commit('error/setErrorCode', response.data.code, { root: true })
    },
    // 請求一覧CSV取得
    async getInvoicesCSVApi(context, params) {
        context.commit('setApiStatus', null)
        const response = await getApi('import_invoices_list_csv', params)
        if (response.data.code === OK) {
            context.commit('setApiStatus', true)
            let mineType = 'text/csv'
            const name = response.data.data.name
            const shiftJisCodeList = Encoding.convert(strArray(response.data.data.csv), 'sjis', 'unicode')
            const uInt8List = new Uint8Array(shiftJisCodeList)
            const blob = new Blob([uInt8List], { type: mineType })
            saveAs(blob, name)
            return false
        }

        // 共通エラー処理
        context.commit('error/setApiStatus', true, { root: true })
        context.commit('error/setErrorCode', response.data.code, { root: true })
    },
    // 売上CSV取得
    async getInvoicesEarningsCSVApi(context, params) {
        context.commit('setApiStatus', null)
        const response = await getApi('invoice_earnings_export', params)
        if (response.data.code === OK) {
            context.commit('setApiStatus', true)
            const name = response.data.data.name
            saveAs(response.data.data.url, name)
            return false
        }

        // 共通エラー処理
        context.commit('error/setApiStatus', true, { root: true })
        context.commit('error/setErrorCode', response.data.code, { root: true })
    },
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}